(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["treads-detailing-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('treads-detailing-controls')) {
  customElements.define('treads-detailing-controls', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound) return;
      this.dataset.bound = 'true';
      this.addEventListener('change', () => {
        const category = this.querySelector('[data-detail-category]').value;
        const brand = this.querySelector('[data-detail-brand]').value;
        const sort = this.querySelector('[data-detail-sort]').value;
        const existing = JSON.parse(this.dataset.currentTags || '[]') || [];
        const tags = existing.filter(t => !t.startsWith('detail-category-') && !t.startsWith('detail-brand-'));
        if (category) tags.push(category);
        if (brand) tags.push(brand);
        const url = new URL(window.location.href);
        url.pathname = this.dataset.baseUrl + (tags.length ? '/' + tags.map(encodeURIComponent).join('+') : '');
        url.searchParams.delete('page');
        if (sort) url.searchParams.set('sort_by', sort); else url.searchParams.delete('sort_by');
        window.location.assign(url.toString());
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
